var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAmsLogo = function SvgAmsLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "120.75px",
    height: "45.5px",
    viewBox: "0 0 120.75 45.5",
    enableBackground: "new 0 0 120.75 45.5",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M4.846,9.36c0,0.125,0.806,3.021,0.806,3.021H4.061L4.846,9.36z M32.864,8.718 c0.123,0.124,1.177,0.124,1.177,1.799c-0.123,0.685-1.177,1.222-1.177,1.282V8.718z M56.769,9.424l0.805,3.021h-1.735 L56.769,9.424z M17.025,24.17c0.475,0,1.839,0.932,1.839,1.984c0.124,1.86-1.591,2.604-1.839,2.604V24.17z M41.549,24.418 c0.373,0,2.026,0.933,2.086,2.418c0,0.994-1.961,2.297-2.086,2.606V24.418z M48.082,6.281c0.125,0,1.18,1.18,1.18,1.18 s-1.86,2.235-1.735,3.724c0,1.405,1.983,3.888,2.294,4.073c-0.186,0.375-0.559,1.429-1.242,2.234c0-0.123-3.783-3.721-3.16-7.115 C45.478,9.445,46.719,7.461,48.082,6.281 M3.502,7.004c-0.125,0.807-2.791,9.162-2.791,9.162s1.736,0.808,1.984,0.931 c-0.125-0.123,0.436-1.923,0.436-2.11h3.205c0,0.188,0.371,1.738,0.371,1.987c0,0.123,2.108-0.808,2.108-0.931 c-1.737-5.129-2.479-9.039-2.479-9.039H3.502 M12.661,7.004c-0.309,1.675-1.053,5.75-2.045,9.162 c0.183,0,2.045,0.684,2.045,0.807c0,0,0.933-3.04,0.933-3.165l0.806,3.165h1.403l0.994-3.165l0.808,3.289l2.108-1.054 c-0.25-0.25-2.295-8.791-2.295-9.039h-1.303c0,0.496-0.786,4.342-0.786,4.469c0-0.127-1.055-4.098-1.239-4.469H12.661  M22.629,7.004c-0.123,0,0,2.356,0,4.697c0,2.604-0.123,5.271-0.123,5.271h4.816c0.248-1.055,0.496-2.355,0.371-2.355 c-2.025,0.371-1.466,0.557-3.204,0.371v-1.677l2.646-0.683c0,0,0.188-1.902,0.188-1.838c0-0.064-2.15,0.555-2.833,0.555V9.238 h2.894l-0.844-2.234H22.629 M30.568,6.942c0,0,0.247,3.05,0.249,5.006c0,1.984-0.249,5.087-0.249,5.087 c1.363,0,2.296-0.123,2.419-0.123l-0.123-2.668c0-0.063,0.56-0.371,0.56-0.371c0.123,0.184,0.931,3.039,0.931,3.039 c0.247,0,1.425-0.623,1.858-0.806c-0.123-0.25-1.362-3.413-1.179-3.413c0-0.126,1.056-1.841,1.056-2.709 c0-0.686-0.93-2.422-2.049-3.042H30.568z M39.563,7.004c0.063,5.75,0,8.17,0,9.969h2.462c0-0.496-0.372-6.682-0.126-9.969H39.563 z M55.465,7.066c-0.248,0.684-3.08,9.223-3.08,9.223s1.901,0.746,2.025,0.746c0,0,0.496-1.923,0.682-1.923h3.041 c0,0.062,0.248,1.675,0.248,1.923c0.187,0,2.295-0.746,2.418-0.929c-1.86-5.067-2.668-9.04-2.668-9.04H55.465 M70.291,6.487 c0,0-2.295,0.808-2.418,0.931c0,0.125,0.312,3.971,0.312,4.096c0,0-2.607-3.723-2.856-4.219c-0.906,0-1.031,0.123-1.715,0 c0,0,0.188,9.16,0,9.16c0.436,0.189,2.148,0.561,2.396,0.81v-4.903l3.352,4.903c0,0,0.809-0.62,1.057-0.81 C70.414,16.455,70.045,7.791,70.291,6.487 M3.254,19.33c0,0.561-3.102,3.828-1.863,8.17c0.496,1.302,4.387,4.469,0.625,10.527 c0.432,0.247,2.955,1.553,3.762,1.861c0.122-0.311,1.982-3.538,2.294-4.653c0.744-5.875-5.748-8.912-1.117-14.168 C6.832,21.068,3.937,19.455,3.254,19.33 M13.303,20.59c0,0,0.072,6.611,0.061,10.84c-0.005,3.017-0.061,7.736-0.061,7.736h4.633 L17.5,33.664c0-0.437,5.088-3.041,5.522-7.385c-0.435-1.984-3.722-5.502-3.91-5.689H13.303L13.303,20.59z M27.9,20.59 c0.311,10.404-0.124,15.287-0.124,18.576h4.817c0-0.932-0.682-12.762-0.432-18.576H27.9z M43.76,20.779 c-2.77,0-5.563-0.188-5.686-0.188c0,0,0.367,5.552,0.374,9.102c0.004,3.697-0.374,9.475-0.374,9.475h4.262l-0.478-5.938 c0.063,0,1.034-0.745,1.034-0.745c0.063,0.124,2.109,6.433,2.109,6.558c0.311,0,2.233-1.426,2.916-1.737 c-0.063-0.372-2.605-6.681-2.482-6.806c0-0.248,1.8-2.918,1.8-4.342C47.235,24.418,45.498,21.957,43.76,20.779 M51.928,20.59 c0.371,10.404,0,15.287,0,18.576h4.757c-0.124-0.932-0.62-12.762-0.373-18.576H51.928z M61.068,20.59 c0,0.188-0.868,3.332-0.868,3.828h3.288l-0.497,14.748h4.507l-0.683-14.871h2.854c0.373-0.808,0.807-2.834,0.807-3.705H61.068"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#E82C2A",
    d: "M47.789,7.528l0.219,0.237c-0.016,0.014-1.472,1.382-1.502,3.398 c-0.023,1.439,0.672,2.862,2.063,4.229l-0.227,0.23c-1.459-1.432-2.187-2.935-2.16-4.468C46.215,8.998,47.723,7.586,47.789,7.528 "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_6_)",
    fill: "#E82C2A",
    d: "M4.188,8.022H5.59l0.033,0.118l2.047,7.238l-0.31,0.094L6.836,13.85 l-4.17,0.057L2.17,15.472l-0.313-0.089l0.463-1.795l0.105-0.002L4.188,8.022z M5.344,8.346H4.426l-1.657,5.236l4.04-0.057 L5.344,8.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_8_)",
    fill: "#E82C2A",
    points: "13.395,8.89 15.086,14.453 16.813,9.235 18.504,15.443  18.192,15.528 16.782,10.355 15.073,15.522 13.418,10.082 12.012,15.463 11.697,15.381  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#E82C2A",
    points: "23.522,8.021 26.103,8.021 26.103,8.345 23.842,8.345  23.813,12.186 26.192,11.666 26.262,11.981 23.842,12.511 23.786,15.881 26.537,15.881 26.537,16.205 23.457,16.205  23.459,16.041  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_12_)",
    fill: "#E82C2A",
    d: "M31.77,7.709h1.468c0.681,0,2.085,1.56,2.085,2.523 c-0.12,0.787-0.597,1.364-1.104,1.975l-0.121,0.148l1.092,3.453l-0.311,0.097l-1.055-3.342c-0.123,0.063-0.305,0.147-0.576,0.274 c-0.365,0.171-0.965,0.449-1.097,0.557c-0.03,0.13-0.047,0.432-0.058,0.799v1.788l-0.324,0.003c-0.003-0.152-0.021-1.06,0-1.8 V7.709L31.77,7.709z M32.094,13.047c0.188-0.11,0.504-0.264,1.017-0.502c0.286-0.133,0.642-0.297,0.698-0.344L33.971,12 c0.476-0.574,0.925-1.117,1.027-1.793c0-0.865-1.341-2.172-1.761-2.172h-1.144V13.047z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40.436,
    y: 7.81,
    clipPath: "url(#SVGID_14_)",
    fill: "#E82C2A",
    width: 0.324,
    height: 8.354
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_16_)",
    fill: "#E82C2A",
    d: "M56.155,8.082h1.481l1.358,5.377l0.072-0.002l0.399,1.869L59.151,15.4 l-0.408-1.613l-4.157,0.059l-0.584,1.57l-0.306-0.107L56.155,8.082z M57.385,8.406h-0.998l-1.739,5.114l4.017-0.056L57.385,8.406 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_18_)",
    fill: "#E82C2A",
    points: "65.139,15.711 64.814,15.711 64.814,8.816 69.074,14.134  69.074,8.473 69.396,8.473 69.396,15.057 65.139,9.74  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_20_)",
    fill: "#E82C2A",
    d: "M4.42,21.318l0.523,0.367c-0.018,0.023-1.656,2.372-1.374,3.895 c0.237,1.396,0.81,2.475,1.362,3.517c0.594,1.116,1.156,2.173,1.285,3.522c0.131,2.028-0.34,3.297-1.318,5.068L4.34,37.377 c0.936-1.697,1.358-2.836,1.24-4.707c-0.117-1.213-0.648-2.217-1.213-3.275c-0.576-1.087-1.174-2.211-1.429-3.701 C2.607,23.91,4.344,21.422,4.42,21.318"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_22_)",
    fill: "#E82C2A",
    d: "M15.092,22.135h1.933c0.838,0,1.817,0.512,2.62,1.365 c0.863,0.922,1.34,2.063,1.277,3.049c-0.158,2.352-3.533,4.537-4.807,5.361c-0.13,0.084-0.263,0.17-0.345,0.227 c-0.009,0.06-0.022,0.184-0.037,0.428v4.686h-0.459l-0.099-0.103c-0.03-0.032-0.056-0.108-0.075-0.218h-0.009v-0.04 c-0.154-0.96-0.008-4.126,0-4.345V22.135z M15.734,31.396c0.011-0.008,0.021-0.017,0.035-0.022 c1.197-0.774,4.378-2.836,4.515-4.863c0.052-0.813-0.36-1.774-1.106-2.567c-0.674-0.72-1.498-1.166-2.152-1.166h-1.291V31.396z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.752,
    y: 22.205,
    clipPath: "url(#SVGID_24_)",
    fill: "#E82C2A",
    width: 0.639,
    height: 14.729
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_26_)",
    fill: "#E82C2A",
    d: "M39.862,22.01h0.321c2.146,0,4.734,1.115,5.301,3.186 c0.299,1.085,0.091,2.645-1.92,4.539l2.727,6.704l-0.594,0.24l-2.641-6.492c-0.674,0.572-1.516,1.172-2.555,1.796v5.32h-0.64 V22.01z M40.502,31.232c3.295-2.056,4.844-4.129,4.367-5.868c-0.441-1.604-2.506-2.602-4.367-2.706V31.232z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.821,
    y: 22.33,
    clipPath: "url(#SVGID_28_)",
    fill: "#E82C2A",
    width: 0.64,
    height: 14.729
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_30_)",
    fill: "#E82C2A",
    points: "62.43,22.32 68.428,22.32 68.428,22.961 65.398,22.961  65.398,37.057 64.76,37.057 64.76,22.961 62.43,22.961  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_32_)",
    fill: "#E82C2A",
    d: "M76.176,20.561C77.519,8.785,88.149,0.328,99.926,1.672 c11.774,1.344,20.231,11.978,18.896,23.752c-1.34,11.777-11.972,20.236-23.75,18.892C83.297,42.971,74.838,32.338,76.176,20.561"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_34_)",
    fill: "#8E9090",
    d: "M97.467,0.793c0.844,0,1.699,0.05,2.543,0.146 c12.158,1.39,20.927,12.411,19.543,24.569c-1.276,11.224-10.742,19.686-22.021,19.686c-0.845,0-1.702-0.05-2.545-0.146 C82.827,43.66,74.06,32.639,75.441,20.479C76.723,9.256,86.19,0.793,97.467,0.793 M97.533,43.718 c10.526,0,19.364-7.898,20.555-18.376c1.291-11.352-6.894-21.641-18.244-22.938c-0.789-0.091-1.588-0.136-2.375-0.136 c-10.526,0-19.364,7.9-20.561,18.375c-1.291,11.354,6.896,21.645,18.247,22.938C95.944,43.672,96.744,43.718,97.533,43.718"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_36_)",
    d: "M108.983,11.271c1.101,0.503,1.649,0.774,2.747,1.358c0.761,0.836,1.146,1.244,1.927,2.037 c-0.964,0.293-1.508,0.539-2.68,1.177c-0.743-0.796-1.113-1.205-1.841-2.042c0.541-0.432,0.797-0.627,1.271-0.971 C109.832,12.218,109.547,11.904,108.983,11.271"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_38_)",
    d: "M112.887,15.937c0.813,0.75,1.222,1.114,2.041,1.813c-1.379,0.57-2.149,0.998-3.775,2.047 c-0.678-0.635-1.018-0.963-1.689-1.637C110.951,17.062,111.651,16.601,112.887,15.937"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_40_)",
    d: "M114.594,19.149c0.81,0.781,1.213,1.155,2.011,1.862c-1.675,0.754-2.585,1.285-4.46,2.55 c-0.54-0.541-0.814-0.819-1.365-1.397C112.418,20.725,113.201,20.103,114.594,19.149"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_42_)",
    d: "M115.063,22.771c0.593,0.648,0.884,0.961,1.45,1.549c-1.658,0.821-2.514,1.328-4.26,2.465 c-0.422-0.339-0.636-0.515-1.064-0.877C112.812,24.478,113.588,23.834,115.063,22.771"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_44_)",
    d: "M114.811,26.469c0.388,0.671,0.572,0.994,0.917,1.607c-1.918,0.865-2.888,1.362-4.806,2.43 c-0.158-0.575-0.244-0.868-0.427-1.465C112.233,27.901,113.105,27.375,114.811,26.469"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_46_)",
    d: "M113.766,30.125c0.111,0.451,0.162,0.674,0.251,1.107c-2.027,1.084-3.039,1.676-5.015,2.896 c0.057-0.533,0.08-0.803,0.125-1.338C110.963,31.658,111.897,31.114,113.766,30.125"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_48_)",
    d: "M111.84,33.231c-0.201,0.853-0.312,1.28-0.549,2.14c-1.806,0.891-2.697,1.332-4.453,2.188 c0.101-0.522,0.146-0.786,0.24-1.312C108.94,35.002,109.899,34.388,111.84,33.231"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_50_)",
    d: "M107.834,38.004c-0.66,1.131-0.988,1.709-1.623,2.89c-1.639,0.837-2.447,1.226-4.043,1.933 c-0.131-0.23-0.197-0.352-0.334-0.59c0.813-0.357,1.226-0.546,2.051-0.935c0.091-0.603,0.134-0.901,0.221-1.5 C105.576,39.113,106.323,38.752,107.834,38.004"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_52_)",
    d: "M80.866,14.642c-0.133,0.11-0.2,0.166-0.333,0.276c-0.586-0.229-0.875-0.338-1.443-0.543 c1.113-0.715,1.666-1.076,2.756-1.791c4.881-2.065,9.771-4.156,14.979-5.447c3.766,0.722,7.403,1.943,10.844,3.518 c0.551,0.672,0.832,1.004,1.397,1.654c-0.488,0.531-0.756,0.825-1.324,1.458c0.763,1.007,1.147,1.5,1.931,2.453 c-0.434,0.565-0.662,0.864-1.14,1.491c0.863,1.08,1.3,1.604,2.162,2.604c-0.392,0.639-0.593,0.971-1.015,1.656 c0.764,0.703,1.144,1.042,1.893,1.688c-0.525,0.906-0.798,1.381-1.377,2.363c0.455,0.523,0.682,0.777,1.12,1.268 c-0.812,0.672-1.222,1.024-2.04,1.76c0.381,0.967,0.561,1.436,0.883,2.341c-0.865,0.512-1.298,0.774-2.152,1.315 c-0.099,0.791-0.15,1.188-0.267,1.981c-0.599,0.39-0.896,0.588-1.481,0.987c-0.121,0.898-0.188,1.353-0.326,2.257 c-0.924,0.53-1.381,0.796-2.282,1.319c-0.113,0.776-0.172,1.17-0.29,1.951c-0.721,0.271-1.079,0.397-1.796,0.644 c-3.987-1.839-7.718-4.085-11.461-6.304c-1.414-2.285-2.138-3.443-3.507-5.746c0.551-2.51,0.91-3.771,1.67-6.295 c-0.657-0.596-0.982-0.893-1.625-1.479c-0.063-0.78-0.09-1.17-0.129-1.95c0.408-0.531,0.613-0.797,1.022-1.328 C84.688,16.967,83.314,16.099,80.866,14.642"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_53_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_54_)",
    fill: "#FFFFFF",
    d: "M87.598,11.306c2.599,3.141,5.472,6.044,8.402,8.923 c-0.285,0.72-0.431,1.083-0.714,1.811c-0.923-0.396-1.384-0.594-2.302-0.99c-0.005,0.389-0.006,0.58-0.008,0.967 c-0.719,0.499-1.076,0.753-1.792,1.262c0.583,2.332,0.903,3.494,1.573,5.801c-0.756,2.188-1.108,3.293-1.69,5.496 c3.591,2.215,7.171,4.448,10.992,6.321c0.217-0.729,0.327-1.097,0.555-1.817c-1.709-1.346-2.657-2.134-4.647-3.822 c2.439,1.461,3.605,2.123,5.735,3.144c0.576-0.249,0.866-0.375,1.447-0.633c0.052-0.827,0.073-1.241,0.108-2.073 c-2.57-1.074-5.047-2.337-7.457-3.689c2.559,1.123,5.181,2.134,7.883,2.926c0.529-0.342,0.798-0.512,1.335-0.846 c-0.224-0.535-0.341-0.808-0.582-1.362c-2.716-0.761-5.361-1.713-7.952-2.771c3.09,0.782,6.146,1.53,9.314,1.984 c0.438-0.305,0.658-0.451,1.101-0.744c-0.466-0.67-0.709-1.021-1.209-1.74c-2.896-0.531-5.755-1.218-8.583-1.994 c3.159,0.399,6.3,0.74,9.477,1.012c0.592-0.461,0.887-0.688,1.477-1.119c-0.467-0.396-0.704-0.604-1.182-1.025 c-3.395-0.334-6.774-0.752-10.15-1.203c2.256-0.146,3.377-0.215,5.607-0.328c2.104,0.35,3.152,0.515,5.233,0.806 c0.399-0.696,0.599-1.036,0.979-1.696c-0.691-0.648-1.041-0.988-1.744-1.689c-2.153-0.396-3.233-0.599-5.396-0.987 c-1.908-0.134-2.867-0.188-4.794-0.274c1.748-0.264,2.616-0.379,4.337-0.564c2.438,0.417,3.654,0.639,6.081,1.091 c0.177-0.544,0.259-0.813,0.418-1.342c-0.718-0.691-1.075-1.048-1.791-1.778c-2.603-0.662-3.903-0.972-6.499-1.525 c-1.882-0.041-2.822-0.031-4.751,0.031c1.818-0.412,2.701-0.596,4.447-0.883c2.756,0.434,4.132,0.701,6.88,1.325 c0.209-0.681,0.309-1.013,0.486-1.666c-0.619-0.586-0.926-0.884-1.533-1.489c-2.85-0.898-4.27-1.279-7.102-1.887 c-2.379-0.03-3.604,0.027-6.08,0.258c2.373-0.734,3.526-1.051,5.728-1.505c2.997,0.551,4.496,0.93,7.49,1.889 c0.463-0.315,0.687-0.461,1.118-0.731c-0.303-0.392-0.455-0.588-0.754-0.986c-2.883-1.092-5.707-2.094-8.748-2.764 C94.662,9.021,91.086,10.08,87.598,11.306"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_55_",
    x: -82.473,
    y: -81.521,
    width: 282,
    height: 204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_56_)",
    fill: "#FFFFFF",
    d: "M85.87,11.813c-1.526,0.513-2.303,0.786-3.872,1.356 c2.295,1.533,4.576,3.086,6.863,4.632c-0.71,0.909-1.064,1.366-1.768,2.28c0.035,0.686,0.058,1.028,0.109,1.713 c0.645,0.643,0.971,0.966,1.631,1.608c-0.779,2.45-1.149,3.677-1.74,6.115c1.287,2.101,1.959,3.151,3.281,5.231 c0.557-2.201,0.899-3.307,1.646-5.498c-0.606-2.451-0.892-3.688-1.39-6.158c0.662-0.518,0.994-0.771,1.654-1.278 c0.008-0.771,0.016-1.159,0.033-1.932c1.005,0.505,1.514,0.76,2.527,1.268c0.115-0.368,0.174-0.553,0.287-0.921 C91.957,17.506,88.822,14.75,85.87,11.813"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ams_logo.ae426325.svg";
export { ForwardRef as ReactComponent };